export const MCP_SERVER_TABS = {
	GENERAL_SETTINGS: 'mcp-server-general-settings',
	LOGS: 'mcp-server-logs',
} as const;

export const SUPPORT_CENTER_URL =
	'https://support.scoro.com/hc/en-us/articles/39712766664589-Scoro-MCP-server';

export const MCP_PERMISSION_KEYS = {
	VIEW_TOOLS: 'mcp_view_tools',
	MANAGE_TOOLS: 'mcp_manage_tools',
} as const;

export const MCP_FEATURE_NAME = 'mcp_server';

export const LOGS_BATCH_SIZE = 50;
export const SCROLL_LOADER_MARGIN = '800px';
